var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      { staticClass: "ui mini modal", attrs: { id: "edit-group-dialog" } },
      [
        _c("i", { staticClass: "close icon" }),
        _vm._v(" "),
        _vm.form.model.id
          ? _c("div", { staticClass: "header" }, [_vm._v("グループ情報編集")])
          : _c("div", { staticClass: "header" }, [_vm._v("グループ新規作成")]),
        _vm._v(" "),
        _c("div", { staticClass: "content" }, [
          _c(
            "form",
            {
              staticClass: "ui form",
              class: { warning: _vm.form.hasErrors() },
            },
            [
              _c(
                "div",
                { staticClass: "required field" },
                [
                  _c("label", [_vm._v("グループ名")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.model.name,
                        expression: "form.model.name",
                      },
                    ],
                    attrs: { type: "text", placeholder: "グループ名" },
                    domProps: { value: _vm.form.model.name },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(_vm.form.model, "name", $event.target.value)
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("validation-message", {
                    attrs: { form: _vm.form, field: "name" },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              !_vm.form.model.id
                ? _c(
                    "div",
                    { staticClass: "required field" },
                    [
                      _c("label", [_vm._v("ログインID")]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.form.model.login_id,
                            expression: "form.model.login_id",
                          },
                        ],
                        attrs: { type: "text", placeholder: "ログインID" },
                        domProps: { value: _vm.form.model.login_id },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.form.model,
                              "login_id",
                              $event.target.value
                            )
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("validation-message", {
                        attrs: { form: _vm.form, field: "login_id" },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "required field" },
                [
                  _c("label", [_vm._v("パスワード")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.model.password,
                        expression: "form.model.password",
                      },
                    ],
                    attrs: { type: "text", placeholder: "パスワード" },
                    domProps: { value: _vm.form.model.password },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(
                          _vm.form.model,
                          "password",
                          $event.target.value
                        )
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("validation-message", {
                    attrs: { form: _vm.form, field: "password" },
                  }),
                ],
                1
              ),
            ]
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "actions" }, [
          _c("div", { staticClass: "ui cancel button" }, [_vm._v("閉じる")]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "ui green button",
              class: { "loading disabled": _vm.form.waiting },
              on: {
                click: function ($event) {
                  return _vm.save()
                },
              },
            },
            [_vm._v("保存する")]
          ),
        ]),
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "action-menu" }, [
      _c(
        "button",
        {
          staticClass: "ui small positive button",
          attrs: { type: "button" },
          on: {
            click: function ($event) {
              return _vm.openDialog()
            },
          },
        },
        [_c("i", { staticClass: "plus icon" }), _vm._v("新規登録\n    ")]
      ),
    ]),
    _vm._v(" "),
    _c(
      "form",
      { staticClass: "ui form", class: { loading: _vm.loadForm.waiting } },
      [
        _c("table", { staticClass: "ui compact selectable table" }, [
          _vm._m(0),
          _vm._v(" "),
          _c(
            "tbody",
            _vm._l(_vm.groups, function (group) {
              return _c("tr", { key: group.id }, [
                _c("td", [_vm._v(_vm._s(group.name))]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(group.user.login_id))]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(group.user.plain_password))]),
                _vm._v(" "),
                _c("td", [
                  _c(
                    "a",
                    { attrs: { href: "/afadmin/shops?group_id=" + group.id } },
                    [_vm._v(_vm._s(group.shops.length) + "店舗")]
                  ),
                ]),
                _vm._v(" "),
                _c("td", { staticClass: "actions" }, [
                  _c(
                    "button",
                    {
                      staticClass: "ui inverted tiny positive basic button",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          return _vm.openDialog(group)
                        },
                      },
                    },
                    [_vm._v("編集")]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "ui inverted tiny negative basic button",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          return _vm.remove(group)
                        },
                      },
                    },
                    [_vm._v("削除")]
                  ),
                ]),
              ])
            }),
            0
          ),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("グループ名")]),
        _vm._v(" "),
        _c("th", [_vm._v("ログインID")]),
        _vm._v(" "),
        _c("th", [_vm._v("パスワード")]),
        _vm._v(" "),
        _c("th", [_vm._v("店舗数")]),
        _vm._v(" "),
        _c("th", { staticClass: "actions" }, [_vm._v(" ")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }